// Outbound-click tracking. Fires two signals in parallel and never blocks
// the visitor's navigation:
//   1. PostHog client-side capture — subject to consent (declines are silent).
//   2. Server-side POST to /api/outbound-click — writes to MongoDB
//      unconditionally so the click is recorded even when PostHog is opted
//      out or blocked.
//
// Both calls are best-effort. Failures never surface as UI errors.

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const trackOutboundClick = (payload) => {
  const event = { ...payload };

  // Client-side (PostHog). Respects the site-wide consent gate.
  try {
    if (typeof window !== "undefined" && window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture("outbound_click", event);
    }
  } catch { /* swallow; analytics is best-effort */ }

  // Server-side. sendBeacon is preferred because it survives page unload,
  // which happens immediately after the click when target=_blank triggers
  // browser tab switching.
  try {
    const body = JSON.stringify(event);
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      navigator.sendBeacon(`${API}/outbound-click`, blob);
    } else {
      // Fallback: fire-and-forget fetch with keepalive.
      fetch(`${API}/outbound-click`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch { /* swallow */ }
};

// UTM helper. Preserves any existing query parameters on the base URL and
// sets utm_source / utm_medium / utm_campaign / utm_content. `content` may
// be passed as the second argument to `utm.content` or as a third argument.
export const withUtm = (baseUrl, utm, content) => {
  if (!baseUrl || !utm) return baseUrl;
  try {
    const u = new URL(baseUrl);
    if (utm.source)   u.searchParams.set("utm_source",   utm.source);
    if (utm.medium)   u.searchParams.set("utm_medium",   utm.medium);
    if (utm.campaign) u.searchParams.set("utm_campaign", utm.campaign);
    const c = content || utm.content;
    if (c) u.searchParams.set("utm_content", c);
    return u.toString();
  } catch {
    return baseUrl;
  }
};
